// extracted by mini-css-extract-plugin
export default {"table":"ProviderList_table__qD9Xm","row":"ProviderList_row__fw9HH","close":"ProviderList_close__63fRW","edit":"ProviderList_edit__eSf4Y"};